import { apiClient } from './client';

export interface FlowForgeUser {
  id: string;
  email: string;
  displayName: string;
  role: 'Viewer' | 'Editor' | 'Admin';
  lastLoginAt: string | null;
}

export const getUsers = () =>
  apiClient.get<FlowForgeUser[]>('/api/admin/users').then(r => r.data);

export const updateUserRole = (id: string, role: FlowForgeUser['role']) =>
  apiClient.put(`/api/admin/users/${id}/role`, { role }).then(r => r.data);

export const deleteUser = (id: string) =>
  apiClient.delete(`/api/admin/users/${id}`).then(r => r.data);
